/**
 * Homeowner guided tour. One short sentence per page that still exists.
 */
import React, { useEffect, useState } from 'react';
import GuidedTourCard from './GuidedTourCard';
import { stepsForRole } from '../shared/guidedTour';

const ClientTutorial = ({ onClose, onShowStep }) => {
  const [phone, setPhone] = useState(() => typeof window !== 'undefined' && window.innerWidth < 768);
  const steps = stepsForRole('homeowner', { phone });
  const [currentStep, setCurrentStep] = useState(0);
  const step = steps[currentStep];

  useEffect(() => {
    const onResize = () => setPhone(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    if (step && onShowStep) onShowStep(step);
  }, [step, onShowStep]);

  return (
    <GuidedTourCard
      step={step}
      index={currentStep}
      total={steps.length}
      onBack={() => setCurrentStep((value) => Math.max(0, value - 1))}
      onSkip={() => onClose(false)}
      onNext={() => {
        if (currentStep >= steps.length - 1) onClose(true);
        else setCurrentStep(currentStep + 1);
      }}
    />
  );
};

export default ClientTutorial;
